
<div class="container-fluid banner">
     <img class="img-responsive" src="assets/Banner.jpg">
        <div class="container top-left">
              <h1 class="h1">On a Mission to <br>Naturally Heal <br>the World<span class="h2"><br/>Traditional Care for the Modern Lifestyle</span></h1>
              <!-- <a href="https://aayurway.myshopify.com/collections/capsules"  target="_blank">
                <button type="button" class="bb margin">Shop Now <i class="bi bi-chevron-double-right"></i></button>
              </a> -->
        </div>
</div>



<div class="container-fluid box-green">
    <div class="container">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 tc">
        <h2>Our first wave of products will be <br>ready in the US by the end of {{updateDate | date:'yyyy'}}
        </h2>
        </div>
    </div>
</div>



<div class="container-fluid box-grey">
    <div class="container product">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <!-- <span class="product-h">New Products</span> -->
            </div>
        </div>

        <!-- <div class="row">
            <div class="col-lg-1 col-md-1 col-sm-1 arrow">
                <i class="bi-caret-left"></i>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-5 product-img">
                <img src="../../assets/product.png">
            </div>
            <div class="col-lg-5 col-md-5 col-sm-5 discription">
                <h4>Appetite Formula Capsule 100 ct.</h4>
                <span class="sale">$23.75</span>
                <h3>PRICE: $16.63</h3>
                <h3>SKU: 89111</h3>
                <button class="bb2" type="button" (click)="navToProd()" >Buy Now</button>
            </div>
            <div class="col-lg-1 col-md-1 col-sm-1 arrow">
                <i class="bi-caret-right"></i>
            </div>
        </div> -->

        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <!-- <button class="bb" type="button"  (click)="navToProd()">Shop More <i class="bi bi-chevron-double-right"></i></button> -->
            </div>
        </div>
    </div>
</div>



<div class="container-fluid">
    <div class="container-fluid width-adj">
        <div class="col-lg-12 col-md-12 col-sm-12 tc">
        <h2>WHO ARE WE?</h2>
        <p>{{brandData?.brandFullName}} is a global next-generation phytopharmaceutical healthcare company based in the San Francisco Bay Area. 
            The company was born out of the founders’ observations regarding opportunities to improve the health outcomes of individuals.<br><br>
            Based on our experiences working at the executive and clinical level in the healthcare industry for many decades, coupled 
            with some significant family health events, we set out on a mission to naturally heal the world.<br><br>
            This thought process gave birth to natural, affordable, efficacious, scientifically provable, and accessible healthcare products. 
                Eventually, this has become our passion and our company’s mission.
        </p>
        <a routerLink="/about">
            <button type="button" class="bb2 lives">Learn More <i class="bi bi-chevron-double-right"></i></button>
            </a> 
        </div>
    </div>
</div>



<div class="container-fluid box-grey2">
    <div class="container">
        <div class="col-lg-7 col-md-7 col-sm-7">
        <p>Based on our experiences of working at the executive and clinical level in the healthcare industry for many decades, 
            coupled with some significant a family healthy life events we set out on a mission to naturally heal the world.</p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-5">
            <img src="../../assets/health-care.png" class="img-responsive">
        </div>
    </div>
</div>



<div class="container-fluid box-green2">
    <div class="container width-adj">
        <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="">
            <p>From the came natural, affordable, efficacios, scientifically provable and accessible healthcare products have become 
                out passion and our campeny`s misson</p>
        </div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 box-green2-img">
        <div class="">
            <img src="../../assets/natural-herbs.jpg" class="img-responsive" >
            <a  href="https://aayurway.myshopify.com/collections/capsules" target="_blank">
            <button type="button" class="bb2 lives">Learn More <i class="bi bi-chevron-double-right"></i></button>
            </a> 
        </div>
        </div>
    </div>
</div>



<div class="container-fluid">
    <div class="container width-adj tc">
        <div class="col-lg-12 col-md-12 col-sm-12">
        <h2>Our Services</h2>
        <p>We have developed an extensive portfolio of highly effective phytopharmaceuticals, clinically proven products. 
            Inspired by thousands of years of medical wisdom, validated by 21st century scientific and medical evidence, 
            our products, and services are blended to offer the optimum solution in natural healthcare.</p>
        </div>
    </div>
    <div class="container width-adj">
    <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="os-1">
                    <img src="../../assets/DiseaseManagement.png">
                    <figcaption>Disease Management</figcaption>
                    </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
                    <div class="os-2">
                    <img src="../../assets/LifestyleManagement.png">
                    <figcaption>Lifestyle Management</figcaption>
                    </div>
            </div>
      </div>
      <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="os-3">
                <img src="../../assets/Therapy.png">
                <figcaption>Therapy</figcaption>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6">
                <div class="os-4">
                <img src="../../assets/CareService.png">
                <figcaption>Care Services</figcaption>
                </div>
            </div>
      </div>
    </div>
</div>
</div>



<div class="container-fluid box-green3">
        <div class="col-lg-7 col-md-7 col-sm-7">
            <img src="../../assets/HealthyCare.jpg" class="img-responsive">
        </div>
        <div class="col-lg-5 col-md-5 col-sm-5">
        <p>We are focused on helping everyone be and get healthy through our incredible products. We commit to continue to grow our 
            portfolio to maximize our impact on creating healthy earth and population.
        </p>
        </div>
</div>